// extracted by mini-css-extract-plugin
export default {"container":"DeleteTariffModal_container__1xsXi","buttons":"DeleteTariffModal_buttons__GH6KB"};